import { InfoEmbarcacaoView } from "./view-info-embarcacao";
import type { InfoEmbarcacaoProps } from "./types-info-embarcacao";

export function InfoEmbarcacao(props: InfoEmbarcacaoProps) {
  return <InfoEmbarcacaoView {...props} />;
}

export type * from "./types-info-embarcacao";
